import React from 'react';

interface JobPosition {
  title: string;
  department: string;
  location: string;
  salary?: string;
  equity?: string;
  postedDate?: string;
  applyUrl?: string;
}

interface OpenPositionsProps {
  title: string;
  description: string;
  positions: JobPosition[];
}

const OpenPositions: React.FC<OpenPositionsProps> = ({ title, description, positions }) => {
  return (
    <section className="py-16 bg-gray-50" id="open-positions">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">{title}</h2>
          <p className="text-gray-600">{description}</p>
        </div>
        <div className="max-w-4xl mx-auto">
          {positions.map((position, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm p-6 mb-4 hover:shadow-md transition-shadow">
              <div className="flex flex-col md:flex-row md:justify-between md:items-center">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">{position.title}</h3>
                  <p className="text-gray-600 mt-1">{position.department} · {position.location}</p>
                  {position.salary && <p className="text-gray-600 mt-1">{position.salary} {position.equity && `· ${position.equity}`}</p>}
                  {position.postedDate && <p className="text-gray-500 text-sm mt-1">POSTED {position.postedDate}</p>}
                </div>
                <div className="mt-4 md:mt-0">
                  <a
                    href={position.applyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-primary-600 text-white px-6 py-3 rounded-md font-medium hover:bg-primary-700 transition-colors"
                  >
                    Apply now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OpenPositions;